import checkIfItemIsPage from 'utils/checkIfItemIsPage';

const getTagsForItem = (item) => (checkIfItemIsPage(item) && !item.publishedAt ? [{
  tag: 'Unpublished',
}] : []);

export default getTagsForItem;
